import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  FaCar,
  FaGamepad,
  FaCode,
  FaBook,
} from "react-icons/fa";
import Card from "../components/Card";
import ProfilePic from "./ebin.png";

export default function About() {
  // 🔹 renamed to avoid ESLint unused-vars error in CI
  // const [_inView, _setInView] = useState(false);

  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  /* ================= SCROLL REVEAL ================= */
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const section = document.getElementById("skills-section");
  //     if (section) {
  //       const rect = section.getBoundingClientRect();
  //       if (rect.top < window.innerHeight - 100) {
  //         _setInView(true);
  //       }
  //     }
  //   };
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  /* ================= MOUSE GLOW ================= */
  useEffect(() => {
    const move = (e) => {
      setMousePos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  const interests = [
    { name: "Driving", icon: <FaCar className="text-yellow-400 text-3xl" /> },
    { name: "Gaming", icon: <FaGamepad className="text-pink-500 text-3xl" /> },
    { name: "Coding", icon: <FaCode className="text-red-500 text-3xl" /> },
    { name: "Reading", icon: <FaBook className="text-blue-500 text-3xl" /> },
  ];

  return (
    <section className="relative min-h-screen py-20 px-4 overflow-hidden bg-black text-white">

      {/* ================= FLOATING BLOBS ================= */}
      <motion.div
        className="absolute top-[-200px] left-[-200px] w-[500px] h-[500px] bg-green-500/30 rounded-full blur-[120px]"
        animate={{ x: [0, 100, 0], y: [0, 80, 0] }}
        transition={{ duration: 20, repeat: Infinity }}
      />
      <motion.div
        className="absolute bottom-[-200px] right-[-200px] w-[500px] h-[500px] bg-blue-500/30 rounded-full blur-[120px]"
        animate={{ x: [0, -120, 0], y: [0, -100, 0] }}
        transition={{ duration: 22, repeat: Infinity }}
      />

      {/* ================= MOUSE FOLLOW GLOW ================= */}
      <div
        className="pointer-events-none fixed inset-0 z-0"
        style={{
          background: `radial-gradient(
            400px at ${mousePos.x}px ${mousePos.y}px,
            rgba(34,197,94,0.15),
            transparent 80%
          )`,
        }}
      />

      <div className="relative z-10 container mx-auto max-w-5xl">

        {/* Header */}
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-4xl font-bold mb-12 text-center bg-clip-text text-transparent bg-gradient-to-r from-green-400 to-blue-500"
        >
          Learn More About Me
        </motion.h2>

        {/* Profile Section */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="flex flex-col md:flex-row gap-12 mb-16
          bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 shadow-xl"
        >
          <div className="w-full md:w-1/3">
            <img
              src={ProfilePic}
              alt="Ebin Benny"
              className="w-full rounded-xl object-cover shadow-lg"
            />
          </div>

          <div className="flex-1 space-y-6">
            <h3 className="text-2xl font-bold text-green-500 mb-4">
              Software Developer
            </h3>

            <p className="italic">
              Welcome to my portfolio! I'm <strong>Ebin Benny</strong>, a <strong>Software Developer</strong> from
              Kerala, India, specializing in <strong>React, Laravel, Java, and Spring Boot</strong>.
              I build scalable web applications and modern user interfaces.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-6">
              <p><span className="text-green-400">{">"} Birthday:</span> 4 July 2002</p>
              <p><span className="text-green-400">{">"} Age:</span> 24</p>

              <p><span className="text-green-400">{">"} Degree:</span> Masters in IT</p>
              <p><span className="text-green-400">{">"} Phone:</span> 090-3666-8177</p>
              <p><span className="text-green-400">{">"} Email:</span> ebinbenny055@gmail.com</p>
              <p><span className="text-green-400">{">"} City:</span> Thrissur, Kerala, India</p>
              <p><span className="text-green-400">{">"} Freelance:</span> Available</p>
            </div>

            <p className="leading-relaxed">
              In my journey as a developer, I've had the opportunity to work on
              various projects, from creating dynamic websites to developing
              custom software solutions. I'm dedicated to staying updated with
              the latest trends and technologies in the field.
            </p>
          </div>
        </motion.div>

        {/* Cards */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ staggerChildren: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16"
        >
          <Card title="Happy Clients" value="15+" />
          <Card title="Projects" value="10+" />
          <Card title="Hours of Support" value="500+" />
          <Card title="Experience" value="1 Years" />
        </motion.div>

        {/* Interests */}
        <h3 className="text-2xl font-semibold mb-6">Interests</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          {interests.map((interest, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
              className="flex flex-col items-center justify-center
              bg-white/5 backdrop-blur-xl border border-white/10
              p-6 rounded-xl shadow-lg
              hover:scale-105 hover:border-green-400/40 transition-all"
            >
              {interest.icon}
              <p className="mt-3 font-semibold">{interest.name}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
